<div class="neti-config-links">
    <sw-container
        columns="1fr 1fr 1fr"
        gap="15px"
    >
        <mt-button
            variant="primary"
            :link="documentationLink"
            block
        >
            {{ $t('neti-incomplete-order-reminder.config.links.buttonDocumentation') }}
        </mt-button>

        <mt-button
            variant="primary"
            :link="supportLink"
            block
        >
            {{ $t('neti-incomplete-order-reminder.config.links.buttonSupport') }}
        </mt-button>

        <mt-button
            variant="primary"
            :link="descriptionLink"
            block
        >
            {{ $t('neti-incomplete-order-reminder.config.links.buttonDescription') }}
        </mt-button>
    </sw-container>
</div>